import { render } from "./Footer.vue?vue&type=template&id=ddf00548"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=ddf00548&lang=css"
script.render = render

export default script